/**
 * Test status events for Hogeschooltaal
 */
module.exports = {
  SCHEDULED_TEST_OPENED: 'EV-HST-ST-OPENED',
  TERMS_AND_CONDITIONS_ACCEPTED: 'EV-HST-T&C-ACCEPTED',
  EXERCISE_STARTED: 'EV-HST-EX-STARTED',
  EXERCISE_REVIEWED: 'EV-HST-EX-REVIEWED',
  SCHEDULED_TEST_FINISHED: 'EV-HST-ST-FINISHED',
  SCHEDULED_TEST_TIME_RAN_OUT: 'EV-HST-ST-TIME-RAN-OUT',
};
